import { render, staticRenderFns } from "./CreateTodo.vue?vue&type=template&id=57e7c138&scoped=true"
import script from "./CreateTodo.vue?vue&type=script&lang=js"
export * from "./CreateTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e7c138",
  null
  
)

export default component.exports